<template>
    <form-save
            modelName="Tema"
            saveUrl="themes/"
            operation="post"
            id=""
            backUrl="/themes"
            icon="fa-file-text"
    ></form-save>
</template>

<script>
    import FormSave from "./FormSave";

    export default {
        components: {
            FormSave
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Theme/Add.vue